// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__mhCEq","meals-appear":"AvailableMeals_meals-appear__uLFah"};